export const toolsModalStore = {
    state: () => ({
        addVersionsHistoryModalStatus: false,
        exportSmsModalStatus: false,
        exportEmailModalStatus: false,
        exportRegistryModalStatus: false,
    }),
    mutations: {
        setAddVersionsHistoryModalStatus(state, status) {
            state.addVersionsHistoryModalStatus = status;
        },
        setExportSmsModalStatus(state, status){
            state.exportSmsModalStatus = status;
        },
        setExportEmailModalStatus(state, status){
            state.exportEmailModalStatus = status;
        },
        setExportRegistryModalStatus(state, status){
            state.exportRegistryModalStatus = status;
        }
    }
}